import './header.scss'
import { CloseButton } from '@Components/close-button/close-button'
import { useCallback } from 'react'
import { ContainerMessenger } from '../../container-messenger/container-messenger'
import { ContainerMessageType } from '../../container-messenger/types'

export type HeaderProps = {
  title: string
}

export const Header = ({ title }: HeaderProps) => {
  const closeButtonClickHandler = useCallback(() => {
    ContainerMessenger.sendMessage({ type: ContainerMessageType.EXIT, payload: {} })
  }, [])
  return (
    <header className="app-header">
      <CloseButton className={`app-header__close`} onClick={closeButtonClickHandler} />
      <h1 className="app-title">{title}</h1>
    </header>
  )
}
